<template>
  <div class="media-card" style="position:relative;" v-if="file" :class="file.class">
    <v-menu open-on-click open-delay="600" :offset-overflow="true" transition="scale-transition" origin="center"><!-- :absolute="true" attach="#PixabayContainer"  -->
      <template v-slot:activator="{ on }">
        <div v-on="on" class="image_bloc" :class="isPortrait ? 'portrait' : ''" style="cursor: zoom-in;">
          <v-img  :src="thumbnailPath" @load="displayImage" :class="loading === true? 'loading': ''" class="photo">
            <v-icon style="position:absolute;right:6px;top:6px;color:rgba(255,255,255,1);z-index:1;">mdi-magnify-plus</v-icon>
            <v-icon style="position:absolute;right:5px;top:7px;color:rgba(0,0,0,0.3);z-index:0;">mdi-magnify-plus</v-icon>
          </v-img>
          <div class="status">
            <v-icon style="position:absolute;left:10px;bottom:7px;color:white;"> {{ fileToDisplay.icon }} </v-icon>
            <div class="status_title"> {{ file.status }} </div>
            <div style="position:absolute;right:0px;bottom:0px;height:30px;width:34px;background-color:#252735;border-radius:6px 0px 0px 0px;">
              <v-icon style="position:absolute;right:5px;bottom:3px;color:white;">{{ iconFileType }}</v-icon>
            </div>
          </div>
        </div>
      </template>
      <v-img class="elevation-24" style="cursor: default;" :src="thumbnailPath" cover :class=" isPortrait ? zoomPhotoPixabayPortrait : zoomPhotoPixabay"><!-- :class="imageWidth > imageHeight ? zoomPhotoPixabay : zoomPhotoPixabayPortrait" -->
      </v-img>
    </v-menu>
    <div class="text_bloc">
      <div class="photo_name" v-if="mediaProperties">
        {{ mediaProperties.titre }}
      </div>
      <div class="photo_details">
        <span v-html="broadcastDates"></span>
        <span v-html="broadcastHours"></span>
        <span v-html="broadcastDuration"></span>
      </div>
    </div>
    <div class="pt-4" style="position:absolute;bottom:0;width:100%;height:72px;">
      <div id="mediaCardControls" class="justify-space-between"  style="position:absolute;left:0;right:0;margin:auto;width:220px;display:flex;overflow:visible;">
        <v-btn v-if="!suspendable" id="suspendMedia" class="mediaCardControlButton shadow" icon rounded @click="suspendMedia"><v-icon>mdi-pause</v-icon><div class="mediaCardControlButtonText">{{ $t('actions.suspend') }}</div></v-btn>
        <v-btn v-if="suspendable" id="startBroadcast" class="mediaCardControlButton shadow" icon rounded @click="startBroadcast"><v-icon>mdi-play</v-icon><div class="mediaCardControlButtonText">{{ $t('actions.broadcast-now') }}</div></v-btn>
        <v-btn id="editProg" class="mediaCardControlButton shadow" icon rounded @click="editSettings"><v-icon>mdi-calendar-month</v-icon><div class="mediaCardControlButtonText">{{ $t('actions.date-settings') }}</div></v-btn>
        <v-btn id="editMedia" class="mediaCardControlButton shadow" icon rounded @click="editMedia"><v-icon>mdi-pencil</v-icon><div class="mediaCardControlButtonText">{{ $t('actions.change-media') }}</div></v-btn>
        <v-btn id="deleteMedia" class="mediaCardControlButton shadow" icon rounded @click="removeMedia"><v-icon>mdi-trash-can-outline</v-icon><div class="mediaCardControlButtonText">{{ $t('actions.delete-media') }}</div></v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import DBService from '@/services/DBService'

export default {
  props: ['fileToDisplay', 'selectedScreen'],
  data () {
    return {
      file: null,
      loading: true,
      suspendable: false,
      mediaProperties: null,
      mediaTitle: '',
      thumbnailPath: '',
      screens: [],
      isOldFile: false,
      iconFileType: '',
      zoomPhotoPixabay : 'photoPixabay_Zoom',
      zoomPhotoPixabayPortrait: 'photoPixabay_portrait_Zoom',
      isPortrait: null,
    }
  },
  mounted () {
    var serverPath = 'https://sandisplay.allsan.fr/players/' + this.$store.state.selectedSite.SitNom + '/PUB/'
    this.file = this.fileToDisplay
    if (!this.file.fileProps.isOldFile && this.file.fileProps.sites.includes(',')) {
      serverPath = 'https://sandisplay.allsan.fr/players/' + this.file.fileProps.sites.split(',')[0] + '/PUB/'
    } 
    if (this.fileToDisplay.name !== '') {
      this.mediaProperties = this.fileToDisplay.fileProps
      this.iconFileType = this.mediaProperties.media_name.endsWith('.mp4') || this.mediaProperties.media_name.endsWith('.avi') ? 'mdi-video' : 'mdi-image-size-select-actual'
      if (this.file.status === 'Programmé' || !this.mediaProperties.suspendu) {
        this.suspendable = true
      }
      if (this.mediaProperties.ecrans.includes(',')){
        this.screens = this.mediaProperties.ecrans.split(',')
      } else {
        this.screens.push(this.mediaProperties.ecrans)
      }
      if (this.mediaProperties.miniature){     
        if (this.screens[0] !== 'Ligne de caisse') {
          this.thumbnailPath = serverPath + this.screens[0] + '/' + this.mediaProperties.miniature
        } else {
          if (this.media_name.endsWith('avi') || this.media_name.endsWith('mp4')) {
            this.thumbnailPath = serverPath + this.mediaProperties.miniature
          } else {
            this.thumbnailPath = serverPath + this.screens[1] + '/' + this.mediaProperties.miniature
          }
        }
      } else {
        if (!this.mediaProperties.transition_local){
          this.thumbnailPath = serverPath + this.screens[0] + '/bloc_pub1/' + this.mediaProperties.media_name
        } else {
          this.thumbnailPath = serverPath + 'transition_local' + this.mediaProperties.transition_local + '/' + this.mediaProperties.media_name
        }
      }
    } else {
      this.isOldFile = true
      this.iconFileType = this.fileToDisplay.fileProps[0].path.endsWith('.mp4') ? 'mdi-video' : 'mdi-image-size-select-actual'
      if (this.fileToDisplay.fileProps[0].path.endsWith('.mp4')) {
        var folders = this.fileToDisplay.fileProps[0].path.split('/')
        var videoThumbnail = this.fileToDisplay.fileProps[0].name.substring(9,22)
        var videoPath = this.fileToDisplay.fileProps[0].path.substring(0, this.fileToDisplay.fileProps[0].path.lastIndexOf('/'))
        this.thumbnailPath = serverPath + folders[3] + '/' + videoThumbnail + '.jpg'
      } else {
        this.thumbnailPath = 'https://sandisplay.allsan.fr/players' + this.fileToDisplay.fileProps[0].path
      }    
    }
    var img = new Image()
    img.src = this.thumbnailPath
    img.onload = () => {
      this.isPortrait = img.width < img.height
    }
  },
  methods: {
    displayImage: function () {
      this.loading = false
    },
    async suspendMedia () {
      this.$parent.$parent.$parent.$parent.suspendMedia(this.file.fileProps)
      /* await FtpService.suspendImage({
        filename: file.name,
        site: this.$store.state.selectedSite.SitNom,
        screen: this.screen.server_name
      }) */
    },
    async startBroadcast () {
      this.$parent.$parent.$parent.$parent.startMediaBroadcast(this.file.fileProps)
    },
    async removeMedia () {
      this.$parent.$parent.$parent.$parent.confirmRemove(this.file.fileProps, this.isOldFile)
    },
    async editSettings () {
      if (this.isOldFile) {
        this.$parent.$parent.$parent.$parent.editSettings(this.file, this.isOldFile)
      } else {
        this.$parent.$parent.$parent.$parent.editSettings(this.file.fileProps, this.isOldFile)
      }      
    },
    async editMedia () {
      this.$parent.$parent.$parent.$parent.editMedia(this.file.fileProps)
    }
  },
  computed: {
    broadcastDates: function () {
      if (!this.isOldFile){
        if (this.file.fileProps.date_debut && this.file.fileProps.date_fin) {
          return 'Début de diffusion : <b>' + this.file.fileProps.date_debut.substring(8) + '/' + this.file.fileProps.date_debut.substring(5, 7) + '/' + this.file.fileProps.date_debut.substring(0, 4) +
            '</b><br > Fin de diffusion : <b>' + this.file.fileProps.date_fin.substring(8) + '/' + this.file.fileProps.date_fin.substring(5, 7) + '/' + this.file.fileProps.date_fin.substring(0, 4) + '</b>'
          //  return 'Diffusion du <b>' + this.file.start.substring(6) + '/' + this.file.start.substring(4, 6) + '/' + this.file.start.substring(0, 4) + '</b> au <b>' + this.file.end.substring(6) + '/' + this.file.end.substring(4, 6) + '/' + this.file.end.substring(0, 4) + '</b>'
        } else if (this.file.fileProps.date_debut && !this.file.fileProps.date_fin) {
          if (this.file.status === 'Programmé') {
            return 'Diffusion à partir du <b>' + this.file.fileProps.date_debut.substring(8) + '/' + this.file.fileProps.date_debut.substring(5, 7) + '/' + this.file.fileProps.date_debut.substring(0, 4) + '</b>'
          } else {
            return 'Diffusion depuis le <b>' + this.file.fileProps.date_debut.substring(8) + '/' + this.file.fileProps.date_debut.substring(5, 7) + '/' + this.file.fileProps.date_debut.substring(0, 4) + '</b>'
          }
        } else if (!this.file.fileProps.date_debut && this.file.fileProps.date_fin) {
          return 'Diffusion jusqu\'au <b>' + this.file.fileProps.date_fin.substring(8) + '/' + this.file.fileProps.date_fin.substring(5, 7) + '/' + this.file.fileProps.date_fin.substring(0, 4) + '</b>'
        } else {
          return 'Diffusion continue'
        }
      } else {
        var d = this.fileToDisplay.fileProps[0].name.includes('__d') ? this.fileToDisplay.fileProps[0].name.split('__d')[1].substring(0,8) : null
        var f = this.fileToDisplay.fileProps[0].name.includes('__f') ? this.fileToDisplay.fileProps[0].name.split('__f')[1].substring(0,8) : null
        if (d && f) {
          return 'Début de diffusion : <b>' + d.substring(6) + '/' + d.substring(4, 6) + '/' + d.substring(0, 4) +
            '</b><br > Fin de diffusion : <b>' + f.substring(6) + '/' + f.substring(4, 6) + '/' + f.substring(0, 4) + '</b>'
          //  return 'Diffusion du <b>' + this.file.start.substring(6) + '/' + this.file.start.substring(4, 6) + '/' + this.file.start.substring(0, 4) + '</b> au <b>' + this.file.end.substring(6) + '/' + this.file.end.substring(4, 6) + '/' + this.file.end.substring(0, 4) + '</b>'
        } else if (d && !f) {
          if (this.file.status === 'Programmé') {
            return 'Diffusion à partir du <b>' + d.substring(6) + '/' + d.substring(4, 6) + '/' + d.substring(0 ,4) + '</b>'
          } else {
            return 'Diffusion depuis le <b>' + d.substring(6) + '/' + d.substring(4, 6) + '/' + d.substring(0, 4) + '</b>'
          }
        } else if (!d && f) {
          return 'Diffusion jusqu\'au <b>' + f.substring(6) + '/' + f.substring(4, 6) + '/' + f.substring(0, 4) + '</b>'
        } else {
          return 'Diffusion continue'
        }
      } 
    },
    broadcastHours: function () {
      if (!this.isOldFile) {
        if (this.file.fileProps.heure_debut && this.file.fileProps.heure_fin) {
          return ' entre ' + this.file.fileProps.heure_debut.substring(0, 2) + ':' + this.file.fileProps.heure_debut.substring(2) + ' et ' + this.file.fileProps.heure_fin.substring(0, 2) + ':' + this.file.fileProps.heure_fin.substring(2)
        } else {
          return ''
        }
      } else {
        var hd = this.fileToDisplay.fileProps[0].name.includes('__hd') ? this.fileToDisplay.fileProps[0].name.split('__hd')[1].substring(0,4) : null
        var hf = this.fileToDisplay.fileProps[0].name.includes('__hf') ? this.fileToDisplay.fileProps[0].name.split('__hf')[1].substring(0,4) : null
        if (hd && hf) {
          return ' entre ' + hd.substring(0, 2) + ':' + hd.substring(2) + ' et ' + hf.substring(0, 2) + ':' + hf.substring(2)
        } else if (hd && !hf){
          return ' à partir de ' + hd.substring(0, 2) + ':' + hd.substring(2)
        } else if (!hd && hf) {
          return ' jusqu\'à ' + hf.substring(0, 2) + ':' + hf.substring(2)
        } else {
          return ''
        }
      }
    },
    broadcastDuration: function () {
      if (!this.isOldFile){
         return '<br>Durée ' + this.file.fileProps.duree_diffusion + ' sec'
      } else {
        if (this.fileToDisplay.fileProps[0].name.includes('.mp4')) {
          return ''
        } else if (!this.fileToDisplay.fileProps[0].name.includes('__tpf')) {
          return '<br>Durée 10 sec'
        } else {
          var tpf = this.fileToDisplay.fileProps[0].name.split('__tpf')[1]
          if (tpf.includes('_')) {
            tpf = tpf.substring(0, tpf.indexOf('_'))
            return '<br>Durée ' + tpf + ' sec'
          } else {
            tpf = tpf.substring(0, tpf.indexOf('.'))
            return '<br>Durée ' + tpf + ' sec'
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.loading {
  background: rgba(0, 0, 0, 0.12)!important;
}

.loading::after{
  animation: loading 1.5s infinite;
  content: "";
  height: 100%;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
  z-index: 1;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
}
</style>
